import EmailPulseSummaryCards from '../email-pulse-summary-cards/email-pulse-summary-cards.component';
import { giftCardsSummaryCardsConfig } from './gift-cards.config';

/**
 * Gift Cards tab summary cards component.
 * Wrapper around the generic EmailPulseSummaryCards with Gift Cards-specific configuration.
 */
const GiftCardsSummaryCards = () => {
  return <EmailPulseSummaryCards config={giftCardsSummaryCardsConfig} />;
};

export default GiftCardsSummaryCards;
